<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <v-dialog class="loading-dialog"
                  v-model="finishingPicking"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Creating Packing List...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>


        <!--FINISH Colli - Dialog-->
        <v-dialog
                persistent
                v-model="finishPickingDialogState" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Pick Position</span>
                </v-card-title>

                <v-card-text>
                    Please check gross weight!

                    <v-flex xs12 pa-2>
                        <v-text-field
                                suffix="kg"
                                label="Gross weight"
                                v-model="selectedItem.gross_weight"
                                type="number"
                                min="0.001"
                        ></v-text-field>
                    </v-flex>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="openCloseFinishPickingDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="finishPicking()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Add Edit - Picking -->
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Colli</v-toolbar-title>
            <v-toolbar-title v-else>Edit Colli - {{selectedItem.colli_number}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTabIndex"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>COLLI</v-tab>
                <v-tab :disabled="tabsDisabled">PICKING POSITIONS</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTabIndex"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Colli
                                        <!--                                        <v-spacer></v-spacer>
                                                                                <v-autocomplete v-show="!getInitialLoading"
                                                                                                v-if="selectedItem.id > 0"
                                                                                                class="statusSelecter"
                                                                                                :items="statuses"
                                                                                                item-text="name"
                                                                                                item-value="id"
                                                                                                label="Invoice Status"
                                                                                                v-model="selectedItem.invoices_status_id"
                                                                                                readonly
                                                                                ></v-autocomplete>-->
                                        <v-spacer></v-spacer>
                                        <DocumentTokenChip
                                                v-show="selectedItem.documents_id !== 0 && selectedItem.documents_id !== null && !getInitialLoading"
                                                :documentsId="selectedItem.documents_id"
                                                :documentFilename="selectedItem.colli_number + '.pdf'"
                                        >
                                        </DocumentTokenChip>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Package type</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    :items="packageTypes"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Package Type"
                                                    v-model="selectedItem.packagings_types_id"
                                                    required
                                            ></v-autocomplete>
                                        </v-flex>


                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Package dimensions</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    suffix="cm"
                                                    v-show="!getInitialLoading"
                                                    label="Length"
                                                    v-model="selectedItem.length"
                                                    type="number"
                                                    min="1"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    suffix="cm"
                                                    v-show="!getInitialLoading"
                                                    label="Width"
                                                    v-model="selectedItem.width"
                                                    type="number"
                                                    min="1"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    suffix="cm"
                                                    v-show="!getInitialLoading"
                                                    label="Height"
                                                    v-model="selectedItem.height"
                                                    type="number"
                                                    min="1"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Gross weight</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    suffix="kg"
                                                    v-show="!getInitialLoading"
                                                    label="Gross weight"
                                                    v-model="selectedItem.gross_weight"
                                                    type="number"
                                                    min="0.001"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn :loading="finishingPicking" dark color="secondary"
                                                   @click.native="openCloseFinishPickingDialog()">
                                                FINISH PICKING
                                                <v-icon class="white--text" right>fas fa-check</v-icon>
                                            </v-btn>
                                            <v-btn :loading="savingPicking" dark color="secondary"
                                                   @click.native="saveAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>

                            </v-layout>

                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <pickingPositions></pickingPositions>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        Invoice,
        Picking,
        PickingPosition
    } from '../../store/namespace-helper'

    import pickingPositions from '../Invoices/Pickings/PickingPositions/PickingPositions.vue'
    import sendOrderMessage from '../SupplierOrders/SendOrder/SendOrderMessage.vue'
    import DatetimePicker from '../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
    import FakeItem from '../Shared/FakeItem.vue'
    import FakeTable from '../Shared/FakeTable.vue'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'
    import {numberFormatFilters} from '../../mixins/numberFormatFilters'

    /*    import _ from 'lodash' */

    export default {
      components: {
        pickingPositions,
        sendOrderMessage,
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable
      },
      name: 'add-picking',
      mixins: [dateFunctionFilters, initialLoadingMixin, numberFormatFilters],
      props: {
        procurementId: {
          type: Number,
          default: 0
        }
      },
      data () {
        return {
          countries: this.$store.getters.countries,
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          valid_until: '',
          statuses: [],
          packageTypes: [],
          allAccounts: [],
          touchless: true,
          activeTabIndex: 0,
          savingPicking: false,
          finishingPicking: false,
          finishPickingDialogState: false
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadStatuses()
              this.loadPackageTypes()
              this.loadAllAccounts()
              this.initialLoadingTimeout(850)
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(Picking.actions.setSelectedPicking, null)
          this.$store.dispatch(PickingPosition.actions.clearPickingPositions)
          this.$store.dispatch(Picking.actions.openCloseDialog)
          this.selectedPurchasePositionsIDs = []
          this.activeTabIndex = 0
        },
        loadStatuses () {
          this.$store.dispatch(Invoice.actions.loadStatuses).then(response => {
            this.statuses = response.data.data
          })
        },
        loadPackageTypes () {
          this.$store.dispatch(Picking.actions.loadPackageTypes).then(response => {
            this.packageTypes = response.data.data
          })
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        saveAndGoToNextTab (index) {
          this.savingPicking = true
          const picking = {
            id: this.selectedItem.id,
            invoices_id: this.selectedInvoice.id,
            packagings_types_id: this.selectedItem.packagings_types_id,
            length: this.selectedItem.length,
            width: this.selectedItem.width,
            height: this.selectedItem.height,
            gross_weight: this.selectedItem.gross_weight
          }

          this.$store.dispatch(Picking.actions.savePicking, picking).then(response => {
            this.activeTabIndex = index
            this.savingPicking = false
          }).catch(err => {
            console.log(JSON.stringify(err))
            this.savingPicking = false
          })
        },
        finishPicking () {
          this.finishPickingDialogState = false
          this.finishingPicking = true
          const picking = {
            id: this.selectedItem.id,
            gross_weight: this.selectedItem.gross_weight
          }

          this.$store.dispatch(Picking.actions.finishPicking, picking).then(response => {
            this.$echo.private('packing-list-created-chan.' + this.selectedItem.id).listen('PackingListCreated', (payload) => {
              console.log('message sent event: ' + JSON.stringify(payload))
              this.$store.dispatch(Picking.actions.reloadPicking, this.selectedItem).then(response => {
                this.$echo.leave('packing-list-created-chan.' + this.selectedItem.id)
                this.finishingPicking = false
              }).catch(err => {
                console.log(JSON.stringify(err))
                this.finishingPicking = false
              })
            })
          }).catch(err => {
            console.log(JSON.stringify(err))
            this.finishingPicking = false
          })
        },
        openCloseFinishPickingDialog () {
          this.finishPickingDialogState = !this.finishPickingDialogState
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }
      },
      computed: {
        selectedItem () {
          console.log('selected picking: ' + JSON.stringify(this.$store.getters[Picking.getters.getSelectedPicking]))
          return this.$store.getters[Picking.getters.getSelectedPicking]
        },
        selectedInvoice () {
          console.log('selected invoice: ' + JSON.stringify(this.$store.getters[Invoice.getters.getSelectedInvoice]))
          return this.$store.getters[Invoice.getters.getSelectedInvoice]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[Picking.getters.getSelectedPicking].id === 0
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        cardTitle () {
          if (this.selectedItem.id === 0) {
            return 'Add new'
          } else {
            return 'Edit'
          }
        }

      },
      watch: {}

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .header-switch {
        position: absolute;
        right: 24px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddPicking.vue